;
(function(win, UpAct, $) {
    let ua = window.navigator.userAgent;
    let isIOS = (/iPhone|iPad|iPod/i).test(ua);

    const query = function(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || 'search',
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    };

    const addParam = function(url, data) {
        if (typeof data === 'undefined') {
            return;
        }

        var hashReg = /#.*$/gi,
            hashMatch = url.match(hashReg),
            hash = '';

        if (hashMatch) {
            hash = hashMatch[0];
        }

        // 去除hash值的url
        var preUrl = url.replace(hash, '');

        var searchReg = /\?(.*?)$/gi;
        var result = searchReg.exec(preUrl)
        var query, newUrl;
        if (result) {
            query = result[1].split('#')[0];
        }

        var id = !query ? '' : '&';

        return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
    }


    const delQuery = function(url, key) {
        var path = '',
            param = '',
            hash = '';
        if (url.indexOf('?') == -1) {
            path = url;
        } else {
            path = url.substr(0, url.indexOf('?'));
            param = url.substr(url.indexOf('?') + 1);
            if (param.indexOf('#') != -1) {
                hash = param.substr(param.indexOf('#') + 1);
                param = param.substr(0, param.indexOf('#'));
            }
        }
        var params = param.split('&');
        for (var i = params.length - 1; i >= 0; i--) {
            if (params[i].indexOf(key + '=') > -1) {
                params.splice(i, 1);
                break;
            }
        }

        return path + (params.join('&') ? ('?' + params.join('&')) : '') + (hash ? ('#' + hash) : '');
    }

    let envi = function(ua) {
        let platform = {};
        let device = {};
        let env;

        if (ua.match(/uplive/i) || query('pl', 'hash') == 'uplive') {
            platform = {
                val: 2002,
                name: 'uplive',
                isUplive: true
            };
        } else if (ua.match(/micromessenger/i)) {
            // 微信
            platform = {
                val: 1,
                name: 'wechat',
                isWeixin: true
            };
        } else if (ua.match(/qq/i) || ua.match(/and_sq_/i)) {
            // QQ
            platform = {
                val: 4001,
                name: 'qq',
                isQQ: true
            };
        } else if (ua.match(/weibo/i)) {
            // 微博
            platform = {
                val: 8001,
                name: 'weibo',
                isWeibo: true
            };
        } else if (ua.match(/[Tt]witter/i)) {
            // twitter
            platform = {
                val: 2,
                name: 'twitter',
                isTwitter: true
            };
        } else if (ua.match(/FB_IAB/i)) {
            // facebook
            platform = {
                val: 3,
                name: 'facebook',
                isFacebook: true
            };
        } else {
            platform = {
                val: 0,
                name: 'unknown',
                isOther: true
            };
        }

        if (ua.match(/android/i)) {
            device = {
                val: 1,
                name: 'android',
                isAndroid: true
            }
        } else if (ua.match(/iphone|ipad|itouch/i)) {
            device = {
                val: 2,
                name: 'ios',
                isIOS: true
            }
        } else {
            device = {
                val: 3,
                name: 'unknown',
                isOther: true
            }
        }

        let _env = query('env');

        if (!_env || _env == 'null') {
            env = 'pro';
        } else {
            env = _env;
        }

        return {
            device: device,
            platform: platform,
            env: env
        }
    }(navigator.userAgent);

     let setTitle = function(value) {
        var nodeTitle = $('title').eq(0);

        if (value && value !== '') {
            nodeTitle.html(value);
        }

        if (isIOS) {
            let $iframe;

            $iframe = $('<iframe src=""https://g.cdn.upliveapp.com/oauthgame/739266613_b5c5a72bcbb1abe5fdc109b1953f65af%20%281%29.png" style="display:none;border:0;width:0;height:0;"></iframe>');
            $iframe.on('load', function() {
                setTimeout(function() {
                    $iframe.off('load').remove();
                }, 300);
            }).appendTo('body');
        }
    };

    UpAct.device = envi.device;
    UpAct.platform = envi.platform;
    UpAct.BaseUtil = {
        query: query,
        addParam: addParam,
        delQuery: delQuery,
        envi: envi,
        setTitle: setTitle,

    };
    $.getScript = function(url, options) {

        var script = document.createElement('script'),
            isFunction = $.isFunction(options),
            timer;

        // 清除定时器
        function clearTimer() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        }

        // success
        if (isFunction || (options && options.success)) {
            script.onload = function() {
                clearTimer();
                isFunction ? options() : options.success.call(options.context);
            };
        }

        if (!isFunction && options) {
            // failure
            if (options.error) {
                script.onerror = function() {
                    clearTimer();
                    options.error.call(options.context);
                }
            }
            // timeout
            if (options.timeout) {
                timer = setTimeout(function() {
                    timer = null;
                    if (options.error) {
                        options.error.call(options.context);
                    }
                }, options.timeout);
            }
        }

        script.setAttribute('data-path', url);

        script.src = url;

        return document.body.appendChild(script);

    };
    $.smartScroll = function(container, selectorScrollable) {
        // 如果没有滚动容器选择器，或者已经绑定了滚动时间，忽略
        if (!selectorScrollable || container.data('isBindScroll')) {
            return;
        }

        // 是否是搓浏览器
        // 自己在这里添加判断和筛选
        var isSBBrowser;

        var data = {
            posY: 0,
            maxscroll: 0
        };

        // 事件处理
        container.on({
            touchstart: function (event) {
                var events = event.touches[0] || event;
                
                // 先求得是不是滚动元素或者滚动元素的子元素
                var elTarget = $(event.target);
                
                if (!elTarget.length) {
                    return;    
                }
                
                var elScroll;
                
                // 获取标记的滚动元素，自身或子元素皆可
                if (elTarget.is(selectorScrollable)) {
                    elScroll = elTarget;
                } else if ((elScroll = elTarget.parents(selectorScrollable)).length == 0) {
                    elScroll = null;
                }
                
                if (!elScroll) {
                    return;
                }
                
                // 当前滚动元素标记
                data.elScroll = elScroll;
                
                // 垂直位置标记
                data.posY = events.pageY;
                data.scrollY = elScroll.scrollTop();
                // 是否可以滚动
                data.maxscroll = elScroll[0].scrollHeight - elScroll[0].clientHeight;
            },
            touchmove: function () {
                // 如果不足于滚动，则禁止触发整个窗体元素的滚动
                if (data.maxscroll <= 0 || isSBBrowser) {
                    // 禁止滚动
                    event.preventDefault();
                }
                // 滚动元素
                var elScroll = data.elScroll;
                // 当前的滚动高度
                var scrollTop = elScroll.scrollTop();
        
                // 现在移动的垂直位置，用来判断是往上移动还是往下
                var events = event.touches[0] || event;
                // 移动距离
                var distanceY = events.pageY - data.posY;
        
                if (isSBBrowser) {
                    elScroll.scrollTop(data.scrollY - distanceY);
                    elScroll.trigger('scroll');
                    return;
                }
        
                // 上下边缘检测
                if (distanceY > 0 && scrollTop == 0) {
                    // 往上滑，并且到头
                    // 禁止滚动的默认行为
                    event.preventDefault();
                    return;
                }
        
                // 下边缘检测
                if (distanceY < 0 && (scrollTop + 1 >= data.maxscroll)) {
                    // 往下滑，并且到头
                    // 禁止滚动的默认行为
                    event.preventDefault();
                    return;
                }
            },
            touchend: function () {
                data.maxscroll = 0;
            }    
        });

        // 防止多次重复绑定
        container.data('isBindScroll', true);
    };
})(window, window['UpAct'] || (window['UpAct'] = {}), Zepto);


// WEBPACK FOOTER //
// ./js/lib/util/base.js